import React from 'react';

import { withSensors } from './../../../shared/containers/containerSensors'

import IntelligenceDateControl from './intelligenceDateControl'
import getDates from './../../../shared/services/date.service'

import styles from './intelligenceDateTab.module.scss'
import { states } from '../../../reducers/queriesStates';

const IntelligenceInMomentDateTab = props => {
  const { sensorsDataState, sensorsData, isSensorsDataReady } = props

  return (
    <div className={styles.intelligenceDateTab}>
      <div className={styles.date_container}>
        <span>
          {
            sensorsDataState === states.READY && isSensorsDataReady
              ? `Сведения за ${getDates.getDateFormat4(sensorsData.date)}`
              : 'Сведения'
          }
        </span>
      </div>
      <div className={styles.control_container}>
        <IntelligenceDateControl isDataReady={sensorsDataState === states.READY && isSensorsDataReady} />
      </div>
    </div>
  )
}

const areEqual = (prevProps, nextProps) => {
  return prevProps.sensorsDataState === nextProps.sensorsDataState && prevProps.isSensorsDataReady === nextProps.isSensorsDataReady
}

export default withSensors(React.memo(IntelligenceInMomentDateTab, areEqual))